import { render, staticRenderFns } from "./StockSummaryTags.vue?vue&type=template&id=457d8e9c&scoped=true"
import script from "./StockSummaryTags.vue?vue&type=script&lang=js"
export * from "./StockSummaryTags.vue?vue&type=script&lang=js"
import style0 from "./StockSummaryTags.vue?vue&type=style&index=0&id=457d8e9c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d8e9c",
  null
  
)

export default component.exports